module.exports = __webpack_public_path__ + "img/masonry.f8882b02.png";